var React = require('react');
var PropTypes = require('prop-types');
var createReactClass = require('create-react-class');
var Loader = require('react-loader');
var Question = require('./layout/question.jsx');

var Survey = createReactClass({
    componentDidMount: function(){
        this._isMounted = true;
        this.is_not_iOS = !navigator.userAgent.toLowerCase().match(/iphone|ipod|ipad/);

        if(this.is_not_iOS){
            this.routeLeaveHookReturn = this.context.router.setRouteLeaveHook(this.props.routes[this.props.routes.length - 1], this.beforeTransition);
            window.addEventListener('beforeunload', this.beforeUnload);
        }
    },

    componentWillUnmount: function(){
        this._isMounted = false;

        if(this.is_not_iOS){
            this.routeLeaveHookReturn(); // unbind setRouteLeaveHook
            window.removeEventListener('beforeunload', this.beforeUnload);
        }
    },

    leavePromptMsg: 'Warning: All progress may be lost if you exit the survey. Are you sure you want to leave?',

    beforeUnload: function(event){
        if(this.shouldShowLeaveWarning()){
            event.returnValue = this.leavePromptMsg;
        }
    },

    beforeTransition: function(){
        if(this.shouldShowLeaveWarning()){
            return this.leavePromptMsg;
        }
    },

    shouldShowLeaveWarning: function(){
        return this._isMounted && Object.keys(this.props.surveys.error).length === 0 && (this.props.responses.currentResponse.length > 0 || this.props.responses.submission.length > 0);
    },

   handleSubmit: function () {
    this.props.submitResponse();
   },

    render: function(){
        return (
            <Loader loaded={!this.props.responses.isFetching}>
                <Question
                    surveyType={this.props.params.surveyType}
                    progress={this.props.progress}
                    field={this.props.field}
                    handleResponse={this.props.setCurrentResponse}
                    handleSubmit={this.handleSubmit}
                    priorResponse={this.props.priorResponse}
                    responses={this.props.responses}
                    clearResponseValidationError={this.props.clearResponseValidationError}
                    goPreviousSurveyState={this.props.goPreviousSurveyState} />
            </Loader>
        );
    },
    // for making this.context.router available
    contextTypes: {
        router: PropTypes.object.isRequired
    },
});

module.exports = Survey;



// WEBPACK FOOTER //
// ./src/common/routes/survey/components/survey.jsx